import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import { UserInfoService } from '../user-info.service';

@Injectable()
export class EscalationService {

  constructor(private apiRequest: ApiRequestService,
    private appConfig: AppConfig , private userInfoService: UserInfoService) {
}


  getExcelDataDetailByDate(pageNumber: any, limit: any, startDate: any, endDate: any)
  {
    let params: HttpParams = new HttpParams();
    params = params.append('p', pageNumber);
    params = params.append('l', limit);
    params = params.append('startDate', startDate);
    params = params.append('endDate', endDate);
    return this.apiRequest.get(this.appConfig.excel_data_json_url + '/filters/date', params);
  }

getExcelFileByDate(startDate: any, endDate: any): Observable<Object[]> {
  return Observable.create(observer => {

    let params: HttpParams = new HttpParams();
    params = params.append('startDate', startDate);
    params = params.append('endDate', endDate);

      const xhr = new XMLHttpRequest();
      xhr.open('GET', this.appConfig.excel_file_download_url + '/escalations/excel?' +  params , true) ;
      xhr.setRequestHeader('Content-type', 'application/json');

      const token = this.userInfoService.getStoredToken();
      if (token !== null) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + token);
      }
      xhr.responseType = 'blob';

      xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                  const contentType = 'application/vnd.ms-excel';
                  const blob = new Blob([xhr.response], {type: contentType});
                  observer.next(blob);
                  observer.complete();
              } else {
                  observer.error(xhr.response);
              }
          }
      }
      xhr.send();

  });
}









}
